const routes = [
    {
        path: "/30/jgg",
        children: [
            {
                path: "20240415/cgq/:test?",
                component: () => import("@/views/30/jgg/2024041501/index.vue"),
                meta: {
                    sign: "20240415cgq",
                },
            },
            {
                path: "20240415/kcw/:test?",
                component: () => import("@/views/30/jgg/2024041501/index.vue"),
                meta: {
                    sign: "20240415kcw",
                },
            },
            {
                path: "20240415/zl/:test?",
                component: () => import("@/views/30/jgg/2024041502/index.vue"),
                meta: {
                    sign: "20240415zl",
                },
            },
            {
                path: "20240415/zgz/:test?",
                component: () => import("@/views/30/jgg/2024041502/index.vue"),
                meta: {
                    sign: "20240415zgz",
                },
            },
            {
                path: "30_20241021yy1/:test?",
                component: () => import("@/views/30/jgg/20241021/index.vue"),
                meta: {
                    sign: "30_20241021yy1",
                },
            },
            {
                path: "30_20241021wj1/:test?",
                component: () => import("@/views/30/jgg/20241021/index.vue"),
                meta: {
                    sign: "30_20241021wj1",
                },
            },
            {
                path: "30_20241021bf2/:test?",
                component: () => import("@/views/30/jgg/20241021/index.vue"),
                meta: {
                    sign: "30_20241021bf2",
                },
            },
            {
                path: "30_20241021fly2/:test?",
                component: () => import("@/views/30/jgg/20241021/index.vue"),
                meta: {
                    sign: "30_20241021fly2",
                },
            },
            {
                path: "30_20241216slz/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216slz",
                },
            },{
                path: "30_20241216cs/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216cs",
                },
            },{
                path: "30_20241216lxq/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216lxq",
                },
            },{
                path: "30_20241216kcw/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216kcw",
                },
            },{
                path: "30_20241216zly/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216zly",
                },
            },{
                path: "30_20241216hf/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216hf",
                },
            },{
                path: "30_20241216qbb/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216qbb",
                },
            },{
                path: "30_20241216zgz/:test?",
                component: () => import("@/views/30/jgg/20241216/index.vue"),
                meta: {
                    sign: "30_20241216zgz",
                },
            },
            {
                path: "30_20241218test/:test?",
                component: () => import("@/views/30/jgg/20241218/index.vue"),
                meta: {
                    sign: "30_20241218test",
                },
            },
            // {
            //     path: "30_20250217cwd/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217cwd",
            //     },
            // },
            // {
            //     path: "30_20250217cgq/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217cgq",
            //     },
            // },
            // {
            //     path: "30_20250217gj/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217gj",
            //     },
            // },
            // {
            //     path: "30_20250217zk/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217zk",
            //     },
            // },
            // {
            //     path: "30_20250217hjh/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217hjh",
            //     },
            // },
            // {
            //     path: "30_20250217zl/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217zl",
            //     },
            // },
            // {
            //     path: "30_20250217dyx/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217dyx",
            //     },
            // },
            // {
            //     path: "30_20250217zgy/:test?",
            //     component: () => import("@/views/30/jgg/20250217/index.vue"),
            //     meta: {
            //         sign: "30_20250217zgy",
            //     },
            // },
            {
                path: "30_20250414jgf/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414jgf",
                },
            },
            {
                path: "30_20250414ypk/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414ypk",
                },
            },
            {
                path: "30_20250414zyz/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414zyz",
                },
            },
            {
                path: "30_20250414xxj/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414xxj",
                },
            },
            {
                path: "30_20250414hy/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414hy",
                },
            },
            {
                path: "30_20250414tyz/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414tyz",
                },
            },
            {
                path: "30_20250414gl/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414gl",
                },
            },
            {
                path: "30_20250414mjy/:test?",
                component: () => import("@/views/30/jgg/20250414/index.vue"),
                meta: {
                    sign: "30_20250414mjy",
                },
            },
            {
                path: "30_20250421jgf/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421jgf",
                },
            },
            {
                path: "30_20250421ypk/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421ypk",
                },
            },
            {
                path: "30_20250421tyz/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421tyz",
                },
            },
            {
                path: "30_20250421zyz/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421zyz",
                },
            },
            {
                path: "30_20250421xxj/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421xxj",
                },
            },
            {
                path: "30_20250421hy/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421hy",
                },
            },
            {
                path: "30_20250421gl/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421gl",
                },
            },
            {
                path: "30_20250421mjy/:test?",
                component: () => import("@/views/30/jgg/20250421/index.vue"),
                meta: {
                    sign: "30_20250421mjy",
                },
            },
            {
                path: "30_20250616wj/:test?",
                component: () => import("@/views/30/jgg/20250616/index.vue"),
                meta: {
                    sign: "30_20250616wj",
                },
            },
            {
                path: "30_20250616yy/:test?",
                component: () => import("@/views/30/jgg/20250616/index.vue"),
                meta: {
                    sign: "30_20250616yy",
                },
            },
            {
                path: "30_20250616wwq/:test?",
                component: () => import("@/views/30/jgg/20250616/index.vue"),
                meta: {
                    sign: "30_20250616wwq",
                },
            },
            {
                path: "30_20250616zx/:test?",
                component: () => import("@/views/30/jgg/20250616/index.vue"),
                meta: {
                    sign: "30_20250616zx",
                },
            },
            {
                path: "30_20250623wj/:test?",
                component: () => import("@/views/30/jgg/20250623/index.vue"),
                meta: {
                    sign: "30_20250623wj",
                },
            },
            {
                path: "30_20250623yy/:test?",
                component: () => import("@/views/30/jgg/20250623/index.vue"),
                meta: {
                    sign: "30_20250623yy",
                },
            }, 
            {
                path: "30_20250623wwq/:test?",
                component: () => import("@/views/30/jgg/20250623/index.vue"),
                meta: {
                    sign: "30_20250623wwq",
                },
            }, 
            {
                path: "30_20250623zx/:test?",
                component: () => import("@/views/30/jgg/20250623/index.vue"),
                meta: {
                    sign: "30_20250623zx",
                },
            },
            {
                path: "30_20250714kcw/:test?",
                component: () => import("@/views/30/jgg/20250714/index.vue"),
                meta: {
                    sign: "30_20250714kcw",
                },
            },
            {
                path: "30_20250714slz/:test?",
                component: () => import("@/views/30/jgg/20250714/index.vue"),
                meta: {
                    sign: "30_20250714slz",
                },
            },
            {
                path: "30new_20250714slz/:test?",
                component: () => import("@/views/30/jgg/20250714/index.vue"),
                meta: {
                    sign: "30new_20250714slz",
                },
            },
            {
                path: "30_20250714zly/:test?",
                component: () => import("@/views/30/jgg/2025071402/index.vue"),
                meta: {
                    sign: "30_20250714zly",
                },
            },
            {
                path: "30_20250714bf/:test?",
                component: () => import("@/views/30/jgg/2025071402/index.vue"),
                meta: {
                    sign: "30_20250714bf",
                },
            },
            {
                path: "30_20250723kcw/:test?",
                component: () => import("@/views/30/jgg/20250723/index.vue"),
                meta: {
                    sign: "30_20250723kcw",
                },
            },
            {
                path: "30_20250723slz/:test?",
                component: () => import("@/views/30/jgg/20250723/index.vue"),
                meta: {
                    sign: "30_20250723slz",
                },
            },
            {
                path: "30new_20250723slz/:test?",
                component: () => import("@/views/30/jgg/20250723/index.vue"),
                meta: {
                    sign: "30new_20250723slz",
                },
            },
            {
                path: "30_20250723zly/:test?",
                component: () => import("@/views/30/jgg/2025072302/index.vue"),
                meta: {
                    sign: "30_20250723zly",
                },
            },
            {
                path: "30_20250723bf/:test?",
                component: () => import("@/views/30/jgg/2025072302/index.vue"),
                meta: {
                    sign: "30_20250723bf",
                },
            },           
        ],
    },
];

export default routes;
